import React from "react";
import "./Promo.css";

function Promo() {
	return (
		<section className="promo" id="get-in-touch">
			<h1 className="promo__title">GENERAL CONSTRUCTION IN NEW YORK</h1>
			<h2 className="promo__subtitle">MIKDASH DEVELOPMENT</h2>
		</section>
	)
}

export default Promo;